module.exports = __webpack_public_path__ + "static/img/success.3a62345a.png";